import { I18nStore } from "./I18nStore";

// let _i18nStore: I18nStore | undefined;

// export function initI18nStore(options: I18nStoreOptions) {
//   _i18nStore = new I18nStore(options);
// }

// export const i18nStore = new Proxy<I18nStore>({} as any, {
//   get: (_, prop) => {
//     if (!_i18nStore) {
//       throw new Error("I18nStore is not initialized");
//     }
//     return Reflect.get(_i18nStore, prop);
//   },
// });

export const i18nStore = new I18nStore({
  locale: "en",
  messages: {},
});
